import { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import intl from "react-intl-universal";
import { TbWebhook } from "react-icons/tb";
import { ModalCloseButton } from "../../../../../Components/Molecules/ValutDialog";
import { getBaasWebhookEventOptions } from "../../../../../Services/baasApiApi";

const inputClass =
  "h-10 w-full rounded-lg border border-gray-200 px-3 text-sm text-brand-dark outline-none transition focus:border-[#e7a73f] dark:border-brand-dark-border dark:bg-brand-dark-elevated dark:text-gray-100";

export const BaasWebhookCreateModal = ({
  open,
  onClose,
  onSubmit,
  submitting = false,
  eventCatalog = [],
}) => {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [active, setActive] = useState(true);
  const [events, setEvents] = useState([]);
  const eventOptions = getBaasWebhookEventOptions(eventCatalog);

  useEffect(() => {
    if (!open) return;
    const options = getBaasWebhookEventOptions(eventCatalog);
    const defaults = options.includes("account.created")
      ? ["account.created"]
      : options.slice(0, 1);
    setEvents(defaults);
  }, [open, eventCatalog]);

  const resetForm = () => {
    setName("");
    setUrl("");
    setActive(true);
    setEvents([]);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const toggleEvent = (eventName) => {
    setEvents((current) =>
      current.includes(eventName)
        ? current.filter((item) => item !== eventName)
        : [...current, eventName],
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!name.trim() || !url.trim() || events.length === 0) return;

    const success = await onSubmit({
      name: name.trim(),
      url: url.trim(),
      active,
      events,
    });

    if (success) {
      handleClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: "!rounded-2xl !shadow-card" }}
    >
      <form onSubmit={handleSubmit} className="relative px-5 py-6 sm:px-6">
        <ModalCloseButton onClick={handleClose} className="absolute right-3 top-3" disabled={submitting} />
        <div className="flex items-center gap-3 pr-8">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#e7a73f]/15">
            <TbWebhook className="h-5 w-5 text-[#a66f1d]" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-brand-dark dark:text-gray-100">
              {intl.get("baas.api.webhooks.createTitle")}
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {intl.get("baas.api.webhooks.createSubtitle")}
            </p>
          </div>
        </div>

        <div className="mt-5 space-y-4">
          <div>
            <label className="mb-1.5 block text-xs font-medium text-gray-500 dark:text-gray-400">
              {intl.get("baas.api.webhooks.nameLabel")}
            </label>
            <input
              className={inputClass}
              value={name}
              onChange={(event) => setName(event.target.value)}
              placeholder={intl.get("baas.api.webhooks.namePlaceholder")}
              required
            />
          </div>

          <div>
            <label className="mb-1.5 block text-xs font-medium text-gray-500 dark:text-gray-400">
              {intl.get("baas.api.webhooks.urlLabel")}
            </label>
            <input
              className={inputClass}
              type="url"
              value={url}
              onChange={(event) => setUrl(event.target.value)}
              placeholder="https://"
              required
            />
          </div>

          <div>
            <p className="mb-2 text-xs font-medium text-gray-500 dark:text-gray-400">
              {intl.get("baas.api.webhooks.eventsLabel")}
            </p>
            <div className="max-h-48 space-y-2 overflow-y-auto rounded-xl border border-gray-100 p-3 dark:border-brand-dark-border">
              {eventOptions.map((eventName) => (
                <label
                  key={eventName}
                  className="flex cursor-pointer items-center gap-2 text-sm"
                >
                  <input
                    type="checkbox"
                    checked={events.includes(eventName)}
                    onChange={() => toggleEvent(eventName)}
                    className="accent-[#e7a73f]"
                  />
                  <span className="text-brand-dark dark:text-gray-100">
                    {eventName}
                    {intl.get(`baas.api.webhooks.events.${eventName}`) &&
                    intl.get(`baas.api.webhooks.events.${eventName}`) !==
                      `baas.api.webhooks.events.${eventName}` ? (
                      <span className="ml-2 text-xs text-gray-500 dark:text-gray-400">
                        {intl.get(`baas.api.webhooks.events.${eventName}`)}
                      </span>
                    ) : null}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <label className="flex cursor-pointer items-center gap-2 text-sm text-brand-dark dark:text-gray-100">
            <input
              type="checkbox"
              checked={active}
              onChange={(event) => setActive(event.target.checked)}
              className="accent-[#e7a73f]"
            />
            {intl.get("baas.api.webhooks.activeLabel")}
          </label>
        </div>

        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="submit"
            className="btn-primary"
            disabled={submitting || !name.trim() || !url.trim() || events.length === 0}
          >
            {intl.get("baas.api.webhooks.register")}
          </button>
        </div>
      </form>
    </Dialog>
  );
};
